module.exports = __webpack_public_path__ + "static/media/cities-graphic.e00b93ed.svg";